import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Markdown from "react-markdown";
import "../sass/news-detail.scss";
import { fetchJson, getMediaUrl } from "./newsApi";

function NewsDetail() {
  const { id } = useParams();

  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function loadArticle() {
      try {
        setLoading(true);
        setError("");

        const data = await fetchJson(`/articles/${id}?populate=*`);

        if (!cancelled) {
          setArticle(data?.data || null);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || "Unable to load article.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadArticle();

    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) {
    return (
      <div className="news-detail-container">
        <div className="news-status" role="status">
          <span className="news-status-spinner" aria-hidden="true" />
          <p>Loading Articles...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="news-detail-container">
        <div className="news-status news-status--error" role="alert">
          <p>Error: {error}</p>
        </div>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="news-detail-container">
        <div className="news-status">
          <p>Article not found.</p>
        </div>
      </div>
    );
  }

  const attributes = article.attributes || {};
  const categories = attributes.categories?.data || [];
  const media = attributes.media?.data || [];

  const imageMedia = media.find((item) =>
    item?.attributes?.mime?.startsWith("image/")
  );

  const imageUrl = getMediaUrl(imageMedia?.attributes);

  let publishedAt = "";

  if (attributes.publishedAt) {
    const publishedDate = new Date(attributes.publishedAt);

    if (!Number.isNaN(publishedDate.getTime())) {
      const dateTimeFormat = new Intl.DateTimeFormat("en-GB", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      publishedAt = dateTimeFormat.format(publishedDate);
    }
  }

  return (
    <div className="news-detail-container">
      <main className="news-detail">
        <div className="news-detail-category">
          {categories.map((category) => (
            <span
              key={category.id}
              className="news-detail-category-text"
            >
              {category.attributes?.name}
            </span>
          ))}

          {publishedAt && (
            <h5 className="news-detail-date">
              <time dateTime={attributes.publishedAt}>
                {publishedAt.toUpperCase()}
              </time>
            </h5>
          )}
        </div>

        <h1 className="my-5">
          {(attributes.title || "").toUpperCase()}
        </h1>

        {imageUrl && (
          <div className="news-detail-media">
            <img
              src={imageUrl}
              alt={imageMedia?.attributes?.name || attributes.title || "G&Y News"}
              loading="lazy"
              decoding="async"
            />
          </div>
        )}

        <Markdown className="news-detail-body">
          {attributes.body || ""}
        </Markdown>
      </main>
    </div>
  );
}

export default NewsDetail;
